import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const ReferralNotificationListener = () => {
  const { toast } = useToast();

  useEffect(() => {
    const setupRealtimeListener = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) return;

      console.log('[REFERRAL LISTENER] Setting up realtime subscription for user:', user.id);

      const channel = supabase
        .channel('referral-notifications')
        .on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'referrals',
            filter: `referrer_id=eq.${user.id}`,
          },
          (payload: any) => {
            console.log('[REFERRAL LISTENER] Referral update detected:', payload);

            // Check if credits were awarded (credited_at changed from null to a timestamp)
            if (payload.new.credited_at && !payload.old.credited_at) {
              const creditsEarned = payload.new.referrer_credits_awarded || 10;

              toast({
                title: "🎉 Referral Bonus Earned!",
                description: `Someone used your referral code! You earned ${creditsEarned} credits.`,
                duration: 8000,
              });

              console.log('[REFERRAL LISTENER] Toast notification shown for referral:', {
                referralId: payload.new.id,
                creditsEarned,
              });
            }
          }
        )
        .subscribe((status) => {
          console.log('[REFERRAL LISTENER] Subscription status:', status);
        });

      return () => {
        console.log('[REFERRAL LISTENER] Cleaning up subscription');
        supabase.removeChannel(channel);
      };
    };

    setupRealtimeListener();
  }, [toast]);

  return null; // This is a headless component
};
